import React from "react";
import { Box, Tooltip } from "@mui/material";
import { IconEyeBase } from "../common/utils/icons";

interface ViewResourceButtonProps {
  resourceId: string | number;
  tooltipText?: string;
}

const ViewResourceIconButton: React.FC<ViewResourceButtonProps> = ({
  resourceId,
  tooltipText = "Click to view resource",
}) => {
  const handleViewResource = () => {
    window.open(`/resource/all/view/${resourceId}`, "_blank");
  };

  return resourceId ? (
    <Box className="custom-chip" onClick={handleViewResource}>
      <Tooltip title={tooltipText} placement="top">
        <span style={{ display: "inline-flex" }} className="nav-link">
          <IconEyeBase />
        </span>
      </Tooltip>
    </Box>
  ) : null;
};

export default ViewResourceIconButton;
